export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7633.1080d8a8.jpg";